import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cnpj'
})
export class CnpjPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) {
      return '';
    }

    // Remover caracteres não numéricos
    const cnpj = value.replace(/\D/g, '');

    // Aplicar formatação
    return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  }
}
